<template lang="html">
  <section class="product">
    <div class="productos row-center animation" :data-lang="lang" :siteMex="siteMex">

      <template v-for="(producto, key) in $t('productos')">
        <article class="producto-el row-center" :data="producto.slug">
          <router-link :to="$t(`enlaces.${producto.slug}`)" class="enlace-cover" :data="producto.slug"></router-link>
          <span class="background"
            :style="`background:url(/static/img/banner-${producto.slug}-producto.jpg) center/cover no-repeat`"></span>
          <h2 class="title">{{ producto.nombre }}</h2>
        </article>
      </template>


    </div>
    <banner-tienda v-if="lang == 'es' && siteMex == false"></banner-tienda>
  </section>
</template>

<script lang="js">
import bannerTienda from '@/components/views/productos/banner-tienda'
import { mapGetters } from 'vuex';
export default {
  name: 'productos',
  data() {
    return {
      siteMex: false
    }
  },
  mounted() {
    if (window.location.hostname.includes('.com.mx')) {
      this.siteMex = true
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage'
    }),
  },
  components: {
    'banner-tienda': bannerTienda,
  },
}
</script>

<style scoped lang="scss">
/* .product {
    .banner-tienda {
      margin-bottom: 50px;
    }
  } */

.productos {
  height: 100vh;
  width: 100%;
  color: black;
  overflow: hidden;
  background: black;

  &[data-lang="es"] {
    height: calc(100vh - 300px);
  }
  &[data-lang="es"][sitemex="true"] {
    height: 100vh;
  }

  article {
    width: 20%;
    height: 100%;
    position: relative;
    transition: 1s;
    cursor: pointer;
    overflow: hidden;
    transition-delay: .5s;

    .enlace-cover {
      transition: 1s;
      background: rgba(0, 0, 0, .7);
    }

    .background {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 3;
      transition: 1s;
    }


    .title {
      color: white;
      text-align: center;
      transform: translateY(-80px);
      opacity: 0;
      transition: .5s;
      z-index: 6;
      pointer-events: none;
    }

    .title::before {
      width: 100px;
      left: 50%;
      transform: translateX(-50%) scaleX(0);
      transition: .5s;
      z-index: 6;
    }

    &:hover {

      .enlace-cover {
        background: rgba(0, 0, 0, .1);
        transition: 1s;
      }

      .background {
        transform: scale(1.1);
      }

      .title {
        transform: translateY(0);

      }

      .title::before {
        transform: translateX(-50%) scaleX(1);

      }

    }

    &:nth-child(2n) {
      transform: translateY(100vh);
    }

    &:nth-child(2n-1) {
      transform: translateY(-100vh);
    }

  }

  &.launched {

    article:nth-child(2n-1),
    article:nth-child(2n) {

      transform: translateY(0);

      .enlace-cover {
        background: rgba(0, 0, 0, 0);
      }

      .title {
        transform: translateY(20px);
        opacity: 1;
        transition-duration: 2s;
      }

      &:hover {
        .title {
          transition-delay: 0s;
          transition-duration: 1s;
        }
      }
    }
  }

}

@for $i from 1 through 5 {

  .productos article:nth-child(#{$i}) .enlace-cover,
  .productos article:nth-child(#{$i}) .title {
    transition-delay: #{$i / 3 + 1.5}s;
  }
}

@media screen and (max-width: 1330px) {
  .productos article {
    // width: 50%;
    height: 100vh;
  }
}

@media screen and (max-width: 700px) {
  .product .banner-tienda {
    margin-bottom: 0;
  }

  .productos article {
    width: 100%;
    min-height: 20vh;
    padding: 30px 0;
    height: auto;



    &:nth-child(2n-1) {
      transform: translateY(200vh);
    }

    &[data=vino] {
      transition-delay: 0s;
    }

    &[data=aceite] {
      transition-delay: .3s;
    }

    &[data=azafran] {
      transition-delay: .6s;
    }

    &[data=cava] {
      transition-delay: .9s;
    }

    &[data=queso] {
      transition-delay: .9s;
    }
  }

  .productos[data-lang="es"] {
    height: 100vh;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/views/productos/productos.vue